export default __webpack_public_path__ + "static/media/speed-icon-active.09f182a2.webp";